module.exports = __webpack_public_path__ + "img/photo_2023-11-22 14.30.32.ad00bf83.jpg";